import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NotesComponent } from '../notes/notes.component';
import { NotesService } from '../../../shared/services/notes.service';
import { PandoraAsideComponent } from '../pandora-aside/pandora-aside.component';
import { SubmissionHistoryService } from '../../../shared/services/submission-history.service';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap/popover/popover';
import { SubmissionSearchUserInfoObject} from '../search-object';
import { Subscription } from 'rxjs';
import { AnnouncementService } from '../../../shared/services/announcement.service';
import { DateUtil } from '../date-util';

@Component({
    selector: 'submission-history',
    templateUrl: './submission-history.component.html',
    styleUrls: [ './submission-history.component.scss' ]
})
export class SubmissionHistoryComponent implements OnInit {

    @ViewChild('searchAside')
    private searchAside: PandoraAsideComponent;
    @ViewChild('notesAside')
    private notesAside: PandoraAsideComponent;
    @ViewChild('notesComponent')
    private notesComponent: NotesComponent;

    private userInfoSubscription: Subscription;
    userInfo: SubmissionSearchUserInfoObject = new SubmissionSearchUserInfoObject();
    public currentSelectedAnnouncementId: string;
    public currentSelectedAnnouncement: any;
    public isClicked = false;
    eventList = new Array<string>();
    public announcements = new Array<any>();
    public announcementTitle = 'Announcements';

    constructor(private route: ActivatedRoute,
                private router: Router,
                private submissionHistoryService: SubmissionHistoryService,
                private readonly notesService: NotesService,
                private readonly announcementService: AnnouncementService) {
        notesService.noteRequested$.subscribe(
            uuid => {
                this.openNote(uuid, event);
            });
    }

    ngOnInit() {
        this.route.queryParams
            .subscribe(params => {
                if (params.openSearchAside === 'true') {
                    setTimeout(() => {
                        this.searchAside.toggleAside(true, event);
                    }, 100);
                }
            });

        this.userInfoSubscription = this.submissionHistoryService.currentUserInfo.subscribe(message => {
            this.userInfo = message
            this.getAnnouncements(this.userInfo);
        })
    }

    getAnnouncements(userInfo: SubmissionSearchUserInfoObject) {
        this.announcementService.getActiveAnnouncements().subscribe(data => {
            data.forEach( (announcement) => {
                if (announcement.announcementType.announcementTypeCde.includes('OUTAGE')) {
                    this.eventList.push(`<span class="announcement" style="color: red" id="` + announcement.announcementId + `" name="announcement" ><i style="vertical-align: middle" class="material-icons">error_outline</i><b>` + announcement.announcementType.announcementTypeCde + `: </b>` + announcement.announcementTitle + '</span>');
                } else {
                    this.eventList.push(`<span class='announcement' id="` + announcement.announcementId + `" name="announcement" ><b>` + announcement.announcementType.announcementTypeCde + `: </b>` + announcement.announcementTitle + '</span>');
                }
            })
            this.announcements = data;
        });
    }

    openNote(uuid: string, event: any) {
        this.submissionHistoryService.getNotes(uuid).then(response => {
                this.notesComponent.finalHeight = "40";
                this.notesComponent.reset(uuid, response);
                this.notesAside.toggleAside(true, event);
        });
    }

    extract() {
      alert('Extract Table Time');
    }

    togglePopoverOnClick(popover: NgbPopover) {
        if (this.isClicked === false) {
            this.isClicked = true;
            popover.open();
        } else {
            this.isClicked = false;
            popover.open();
        }
    }

    popoverHoverOut(popover: NgbPopover) {
        if (popover.isOpen() && !this.isClicked) {
            popover.close();
        }
    }

    public openAnnouncementDetails(popover: NgbPopover, currentAnnouncement: any): void {
        if (!popover.isOpen()) {
            this.currentSelectedAnnouncementId = currentAnnouncement.getElementsByClassName('announcement')[0].id;
            this.currentSelectedAnnouncement = this.announcements.find(x => x.announcementId === this.currentSelectedAnnouncementId)
            popover.open();
        }
    }

    public updateAnnouncement() {
        this.router.navigate(['/admin/announcements/', this.currentSelectedAnnouncementId]);
        return false;
    }

    public convertDate(date: any) {
        return DateUtil.formatDateISO(date);
    }
}
